import { motion } from "framer-motion";
import { Search, PenTool, Calculator, FileText, Layers, HardHat, ArrowRight } from "lucide-react";

const STEPS = [
  { n: "01", icon: Search, title: "Diagnóstico", desc: "Visita técnica gratuita o videollamada para entender tu espacio, uso, clima y necesidades." },
  { n: "02", icon: PenTool, title: "Diseño", desc: "Renders 3D y propuestas conceptuales con varias opciones de forma, materiales y colores." },
  { n: "03", icon: Calculator, title: "Ingeniería", desc: "Memoria de cálculo certificada, simulación de túnel de viento y planos de detalle." },
  { n: "04", icon: FileText, title: "Cotización formal", desc: "Cotización detallada con materiales, tiempos y plan de pagos. Sin sorpresas." },
  { n: "05", icon: Layers, title: "Fabricación", desc: "Producción en taller con membranas importadas y soldadura de alta frecuencia." },
  { n: "06", icon: HardHat, title: "Instalación", desc: "Equipo certificado, instalación profesional con garantía por escrito y mantenimiento gratis a los 6 meses." },
];

export default function Process() {
  const goToForm = () => {
    window.dispatchEvent(new CustomEvent("vt:prefillQuote", {
      detail: { description: "Quiero agendar mi diagnóstico técnico gratuito" },
    }));
    const el = document.getElementById("cotiza");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="proceso" data-testid="process-section" className="bg-[#F2F4ED] text-[#1F2937] section-pad relative">
      <div className="container-tight">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker">Proceso · Del concepto a la instalación</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl leading-[0.95] max-w-4xl">
          Cómo trabajamos con<br />
          <span className="text-accent">cada cliente</span>.
        </h2>
        <p className="mt-6 max-w-2xl text-[#1F2937]/70 text-base md:text-lg">
          Un proceso integral de 6 etapas con ingeniería certificada en cada paso. Garantía por escrito y mantenimiento gratuito a los 6 meses.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#F0F4DC]">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="relative bg-white p-8 lg:p-10 group hover:bg-[#F2F4ED] transition-colors overflow-hidden"
                data-testid={`process-step-${step.n}`}
              >
                <span
                  className="absolute -top-3 -right-2 font-display font-black text-accent/20 select-none pointer-events-none leading-none"
                  style={{ fontSize: "112px" }}
                >
                  {step.n}
                </span>
                <Icon className="w-7 h-7 text-accent relative z-10" />
                <h3 className="mt-5 font-display font-black text-2xl text-[#1F2937] relative z-10">
                  {step.title}
                </h3>
                <p className="mt-3 text-[#1F2937]/65 text-[14px] leading-relaxed relative z-10">
                  {step.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            type="button"
            onClick={goToForm}
            className="btn-accent group"
            data-testid="process-cta"
          >
            Empieza con el diagnóstico gratuito
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
}
